.formLabel {
  display: block;
  margin-bottom: 8px;
  font-weight: 600;
  font-family: var(--font-family-base);
}

.formInput {
  width: 100%;
  padding: 10px 12px;
  font-size: 16px;
  border-radius: 8px;
  border: 1px solid #ccc;
  box-sizing: border-box;
  font-family: var(--font-family-base);
}

.formError {
  margin-top: 12px;
  color: #b00020;
  font-size: 14px;
}

.formSubmit {
  width: 100%;
  min-height: 48px;
  margin-top: var(--space-4);
  padding: 0 var(--button-padding-x);
  border-radius: var(--button-radius);
  border: 0;
  background-color: var(--color-primary-subtle);
  color: var(--color-text);
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
  cursor: pointer;
  box-shadow: none;
  transition:
    background-color 160ms ease,
    border-color 160ms ease,
    color 160ms ease;
}

.formSubmit:hover:not(:disabled) {
  background-color: #e2e8ff;
  border-color: #aebcff;
  color: var(--color-primary-hover);
}

.formSubmit:active:not(:disabled) {
  background-color: #d8e0ff;
}

.formSubmit:focus-visible {
  outline: 3px solid var(--color-focus-ring);
  outline-offset: 2px;
}

.formSubmit:disabled {
  cursor: not-allowed;
  background-color: var(--button-disabled-background-color);
  border-color: var(--button-disabled-border-color);
  color: var(--button-disabled-color);
}
